var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 324,
    viewBox: "0 0 316 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_30)",
    filter: "url(#filter0_d_55_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.854 201.368C250.318 207.636 243.838 213.374 236.49 218.35C223.625 227.068 211.069 231.62 198.706 232.921C171.318 235.805 144.76 222.748 117.275 203.528C103.369 193.817 88.5378 185.205 73.1655 179.93L33.0297 245.988C28.7674 252.96 26.3369 261.157 26.3369 269.923C26.3369 295.372 46.9547 316 72.4138 316H243.587C269.027 316 289.664 295.372 289.664 269.923C289.664 261.157 287.215 252.96 282.971 245.988L255.854 201.368Z",
    fill: "url(#paint0_linear_55_30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.491 36V105.336L282.971 245.988C287.215 252.96 289.664 261.158 289.664 269.923C289.664 295.372 269.027 316 243.587 316H72.4138C46.9547 316 26.3369 295.372 26.3369 269.923C26.3369 261.157 28.7674 252.96 33.0297 245.988L118.491 105.337V36",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.164 19.75C208.164 29.2755 200.431 37.0001 190.914 37.0001H125.087C115.552 37.0001 107.837 29.2771 107.837 19.75C107.837 10.223 115.552 2.5 125.087 2.5H190.914C200.431 2.5 208.164 10.2246 208.164 19.75Z",
    stroke: "black",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_55_30",
    x: -4,
    y: 0,
    width: 324,
    height: 324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_30"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_30",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_30",
    x1: 158.001,
    y1: 179.93,
    x2: 158.001,
    y2: 316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0000FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 316,
    height: 316,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.1a0e0ff5444d0a6719629ecbddab797c.svg";
export { ForwardRef as ReactComponent };